import React from "react";
import moment from "moment";
import { DateRangePicker } from "../../../shared/DateRangePicker/DateRangePicker";
import { svg } from "../../../assets/svg";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { Button } from "../../../shared/Button/Button";
const TimeCardFilter = ({
  startDate,
  endDate,
  isTimeCardPracticeDetail,
  handleDateFilter,
  handleDownload,
}) => {
  const { tCommon } = useAppTranslation.Common();

  const onRangeChange = ({ startDate, endDate }) => {
    const result = {
      fromDate: moment(startDate).format("YYYY-MM-DD"),
      toDate: moment(endDate).format("YYYY-MM-DD"),
    };
    if (isTimeCardPracticeDetail) {
      result.detailStartDate = startDate;
      result.detailEndDate = endDate;
    } else {
      result.selectedStartDate = startDate;
      result.selectedEndDate = endDate;
    }
    handleDateFilter(result);
  };

  return (
    <div className="setting-setion m-b-10">
      <div className="membership-title">
        <div className="d-flex justify-end gap-16">
          <DateRangePicker
            value={{
              startDate: moment(startDate).toDate(),
              endDate: moment(endDate).toDate(),
            }}
            onChange={onRangeChange}
            size="small"
          />
          <Button
            size="small"
            variant="outlined"
            onClick={handleDownload}
            leftAdornment={
              <img src={svg.downloadPrimary} alt="dl" width="20px" />
            }
          >
            {tCommon("label.downloadExcel")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TimeCardFilter;
